import React from 'react';
import { Grid, Typography } from '@mui/material';
import GlassCard from '../../../ui/glass/components/GlassCard';

const formatCurrency = (amount) => (amount ?? 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });

const AccountSummaryHeader = ({ customer, finalBalance }) => {
    return (
        <GlassCard sx={{ p: 3, mb: 3 }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Typography variant="h6">{customer.adSoyad}</Typography>
                    <Typography color="text.secondary">{customer.telefon}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ textAlign: { sm: 'right' } }}>
                    <Typography variant="h6" color={finalBalance > 0 ? 'error.main' : finalBalance < 0 ? 'info.main' : 'success.main'}>
                        GÜNCEL BAKİYE: {formatCurrency(finalBalance)}
                    </Typography>
                    {finalBalance < 0 && (
                        <Typography variant="caption" color="info.main">
                            Bu müşteriye borcunuz bulunmaktadır.
                        </Typography>
                    )}
                    {finalBalance === 0 && (
                        <Typography variant="caption" color="success.main">
                            Hesap dengededir.
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </GlassCard>
    );
};

export default AccountSummaryHeader;
